import { render, staticRenderFns } from "./form-signatario.vue?vue&type=template&id=1957b870&"
import script from "./form-signatario.vue?vue&type=script&lang=js&"
export * from "./form-signatario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports